import type { EmailAddressResponse } from '../../repositories/account-repo/schemas/email-address.zod';
import { EmailConfirmStatus } from '../../repositories/account-repo/schemas/email-address.zod';

export class EmailAddress {
  constructor(private apiResponse: EmailAddressResponse) {}

  public getEmailId() {
    return this.apiResponse.emailId;
  }

  public getEmailAddress() {
    return this.apiResponse.emailAddress;
  }

  public getConfirmStatus() {
    return this.apiResponse.confirmStatus;
  }

  public isConfirmed() {
    return this.apiResponse.confirmStatus === EmailConfirmStatus.CONFIRMED;
  }

  public isUnconfirmed() {
    return this.apiResponse.confirmStatus === EmailConfirmStatus.UNCONFIRMED;
  }

  public getRoles() {
    return this.apiResponse.roles;
  }

  public getPendingRoles() {
    return this.apiResponse.pendingRoles;
  }

  public getFromEmailAddress() {
    return this.apiResponse.fromEmailAddress;
  }

  public getConfirmTime() {
    return this.apiResponse.confirmTime;
  }

  public getConfirmSource() {
    return this.apiResponse.confirmSource;
  }

  public getConfirmSourceType() {
    return this.apiResponse.confirmSourceType;
  }
}
